import { jsxs as e, jsx as a } from "react/jsx-runtime";
import { c as s } from "../../cn-gv_k3DnN.js";
function i({ className: r, ...t }) {
  return /* @__PURE__ */ e(
    "div",
    {
      role: "status",
      "aria-live": "polite",
      className: s("relative size-s-10", r),
      ...t,
      children: [
        /* @__PURE__ */ a("span", { className: "sr-only", children: "Loading, please wait..." }),
        /* @__PURE__ */ e("svg", { className: "rounded-xl fill-none", viewBox: "0 0 100 100", children: [
          /* @__PURE__ */ a(
            "rect",
            {
              strokeDasharray: "400",
              className: "stroke-[8px] stroke-(--fui-color-accent-5)",
              x: "0",
              y: "0",
              width: "100",
              height: "100",
              rx: "16",
              ry: "16"
            }
          ),
          /* @__PURE__ */ a(
            "rect",
            {
              strokeDasharray: "200",
              className: "stroke-[8px] stroke-(--fui-color-accent-3) animate-loader-draw",
              x: "0",
              y: "0",
              width: "100",
              height: "100",
              rx: "16",
              ry: "16"
            }
          ),
          /* @__PURE__ */ a(
            "rect",
            {
              strokeDasharray: "200",
              className: "stroke-[8px] stroke-(--fui-color-accent-5) animate-loader-draw animation-delay-800",
              x: "0",
              y: "0",
              width: "100",
              height: "100",
              rx: "16",
              ry: "16"
            }
          ),
          /* @__PURE__ */ a(
            "rect",
            {
              strokeDasharray: "200",
              className: "stroke-[8px] stroke-(--fui-color-accent-0) animate-loader-draw animation-delay-1600",
              x: "0",
              y: "0",
              width: "100",
              height: "100",
              rx: "16",
              ry: "16"
            }
          )
        ] }),
        /* @__PURE__ */ a(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: "56",
            height: "52",
            fill: "none",
            className: "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2",
            children: /* @__PURE__ */ a(
              "path",
              {
                fill: "#2E8F7B",
                d: "M52.498 6.537v38.926c0 2.154 1.374 3.23 2.711 4.197.855.668.447 2.34-.816 2.34H41.62c-1.3 0-1.633-1.709-.817-2.34 1.338-.966 2.712-1.968 2.712-4.197V11.885L28.578 34.988c-.817 1.264-2.674 1.3-3.528.111L10.23 14.523l.037 30.94c0 2.154 1.375 3.23 2.712 4.197.854.668.445 2.34-.818 2.34H1.835c-1.3 0-1.633-1.709-.816-2.34 1.342-.966 2.706-1.931 2.706-4.197L3.688 6.537c0-2.266-1.411-3.232-2.748-4.197C.129 1.71.46 0 1.762 0h7.317a3.887 3.887 0 0 1 3.157 1.635l17.197 24.184L45.031 1.41C45.627.445 46.519 0 47.298 0h7.132c1.3 0 1.634 1.709.816 2.34-1.337.965-2.748 1.931-2.748 4.197"
              }
            )
          }
        )
      ]
    }
  );
}
export {
  i as Loader
};
